export const COLORS = {
  amethyst: '#A16FC3',
  amethystDark: '#4F2B64',
  amethystLight: '#F6F1F9',
  black02: '#FAFAFA',
  black04: '#F5F5F6',
  black06: '#F0F1F1',
  black08: '#EBECED',
  black10: '#E6E7E8',
  black20: '#CECFD2',
  black30: '#B5B7BB',
  black40: '#9C9FA5',
  black50: '#83878E',
  black60: '#6B6F77',
  black70: '#525761',
  black80: '#393F4A',
  black90: '#212734',
  blackTransparent: 'rgba(8, 15, 29, 0.5)',
  blue: '#3266F5',
  blueDark: '#0B46EA',
  blueLight: '#E6EBF9',
  budGreen: '#78BA78',
  budGreenDark: '#325D32',
  budGreenLight: '#F2F8F2',
  charcoal: '#70919F',
  charcoalDark: '#27404A',
  charcoalLight: '#E4F0F5',
  coral: '#FF7C4F',
  coralDark: '#CC3300',
  coralLight: '#FFF0EB',
  crayola: '#FF524F',
  crayolaDark: '#CC0300',
  crayolaLight: '#FFEBEB',
  ecru: '#AC995D',
  ecruDark: '#51482A',
  ecruLight: '#F8F7F2',
  goldMetalic: '#DBB200',
  goldMetalicDark: '#665300',
  goldMetalicLight: '#FFFBEB',
  green: '#2FB168',
  greenDark: '#22814B',
  greenLight: '#F3FAF6',
  greenPigment: '#1CA056',
  greenPigmentDark: '#157941',
  greenPigmentLight: '#E8F6EE',
  highlight: '#DFE6F9',
  kinetikBlack: '#080F1D',
  kinetikBlue: '#3266F5',
  kinetikBlueDark: '#1551F4',
  kinetikBlueDark2: '#0B46EA',
  kinetikBlueTransparent: 'rgba(50, 102, 245, 0.1)',
  kineticNavy: '#162236',
  kinetikTurquoiseDark: '#32C39C',
  kinetikTurquoiseLight: '#6DD9BC',
  mediumPurple: '#A373F3',
  mediumPurpleDark: '#5814B8',
  mediumPurpleLight: '#F3ECFD',
  myrtleGreen: '#669F9C',
  myrtleGreenDark: '#247671',
  myrtleGreenLight: '#F2F7F6',
  oceanGreen: '#68CA97',
  oceanGreenDark: '#1E5C3E',
  oceanGreenLight: '#F0FAF5',
  orchid: '#E873D8',
  orchidDark: '#68125B',
  orchidLight: '#FCEEFA',
  red: '#F04A2D',
  redDark: '#BF280D',
  redLight: '#FFF0EB',
  rust: '#E47D41',
  rustDark: '#B54708',
  rustLight: '#FFEEE0',
  salmon: '#E9806E',
  salmonDark: '#C3361D',
  salmonLight: '#FEF0EE',
  selectiveYellow: '#F5B400',
  selectiveYellowDark: '#CC9600',
  selectiveYellowLight: '#FFFAEB',
  skyBlue: '#60C7E6',
  skyBlueDark: '#14637B',
  skyBlueLight: '#DCF3F9',
  stPatricksBlue: '#6A659F',
  stPatricksBlueDark: '#2A2476',
  stPatricksBlueLight: '#F2F2F7',
  tomato: '#F66951',
  tomatoDark: '#C2260A',
  tomatoLight: '#FEEEEB',
  vermillion: '#E53010',
  vermillionDark: '#99200B',
  vermillionLight: '#FEEFEC',
  weatherBackground: 'rgba(92, 92, 255, 0.1)',
  white: '#FFFFFF',
  yellow: '#FFA10A',
  yellowDark: '#A36500',
  yellowLight: '#FFF9F0',
  avatar: {
    blue: '#507AEF',
    orange: '#F68251',
    aqua: '#60C7E6',
    violet: '#A16FC3',
    jungleGreen: '#2EB28F',
    ecru: '#AC995D',
    pink: '#E873D8',
    red: '#F66969',
    yellow: '#DBB200',
    gray: '#6B6F77',
    green: '#63C063',
    kinetikTurquoiseLight: '#32C39C',
  },
  majorelleBlueDark: '#221093',
  majorelleBlue: '#6449E9',
  majorelleBlueLight: '#EFEDFD',
  dataRust: '#E47D41',
  dataRustLight: '#FFF2E7',
  dataRustDark: '#B54708',
};

export const BREAKPOINTS = {
  mobile: [0, 767],
  tablet: [768, 1025],
  desktopSmall: [1024, 1349],
  desktopMedium: [1350, 1920],
  desktopLarge: [1921, 9999],
};

export const MEDIA = {
  mobileDown: `@media (max-width: ${BREAKPOINTS.mobile[1]}px)`,
  tabletUp: `@media (min-width: ${BREAKPOINTS.tablet[0]}px)`,
  tabletDown: `@media (max-width: ${BREAKPOINTS.tablet[1]}px)`,
  desktopSmallUp: `@media (min-width: ${BREAKPOINTS.desktopSmall[0]}px)`,
  desktopSmallDown: `@media (max-width: ${BREAKPOINTS.desktopSmall[1]}px)`,
  desktopMediumUp: `@media (min-width: ${BREAKPOINTS.desktopMedium[0]}px)`,
  desktopMediumDown: `@media (max-width: ${BREAKPOINTS.desktopMedium[1]}px)`,
  desktopLargeUp: `@media (min-width: ${BREAKPOINTS.desktopLarge[0]}px)`,
};

export const light = {
  name: 'light',
  light: true,
  dark: false,
  app: {
    primary: '#fff', // tileBackground
    primary2: '#F9F9FD',
    secondary: 'var(--secondary-color)', // accentColor, app.secondary
    background: 'var(--bg-app)', // appBackground
    shadow: '#16aafe55', // themeImgShadow (can use box shadow instead?)
    error: 'var(--bg-error)', // common error color
    darkBlue: '#353d50',
    black: 'var(--text-primary)',
    dropzone: 'var(--bg-input)',
    toggleInactive: '#edf3f8',
    accent: 'var(--accent-color)', // input.hover, input.hover, line.active
    green: 'var(--color-success)',
    resolved: '#00D17A33',
    unread: '#079bab',
    blue: '#0090f9',
    skyBlue: '#0090f90d',
  },
  input: {
    focus: '#E5F2FF',
    hover: '#0073e5',
    rangeValue: '#f5f8fa', // input.rangeValue
    slideTrack: '#dbedff', // input.slideTrack
    slideHandle: '#16aafe', // input.slideHandle
    error: 'var(--bg-error)',
  },
  text: {
    primary: 'var(--text-primary)', // text.primary
    secondary: 'var(--text-secondary)', // and disabled, lgSubText
    inputFocus: '#0575e5',
    inputError: 'var(--text-error)',
    rangeValue: '#f5f8fa',
    link: 'var(--text-link)',
    hover: '#303345',
    smText: '#fff',
    disabled: 'var(--text-disabled)',
    darkGrey: '#595C6A',
    darkBlue: '#08193E',
    brightGrey: '#eaeaea',
    smTextLight: '#FFFFFF99',
    disabledTimePicker: '#a9a9a9',
  },
  buttonBg: {
    primary: 'var(--btn-primary-bg)', // this is primary
    primary2: '#F7F7F8',
    hover3: '#E7E7E7',
    blue: '#E5F2FF',
    green: 'var(--bg-success)',
    red: 'var(--bg-error)',
    orange: '#FFEEE3',
    lightBlue: '#DCF6FA',
    darkBlue: '#2c3648',
    hover: 'white',
    hover2: '#113DD8',
    disabled: '#E6E6E9', // buttonBg.disable
    primaryChecked: '#0073e5',
    unchecked: '#acadb5',
    muiHover: '#1565c0',
    muiError: '#d32f2f',
    cancelBtn: '#fc5c6c',
    hoverCancelBtn: '#fb374b',
    flashWhite: '#F0F0F1',
    darkGrey: '#595C6A',
    hover4: '#e4e4e7',
  },
  buttonText: {
    primary: 'var(--btn-primary-text)',
    action: '#16aafe',
    disabled: '#d9d9d9',
    blue: '#0073E5',
    green: 'var(--color-success)',
    red: '#fd5683',
    orange: '#FF8B33',
    lightBlue: '#04BDD6',
    hover: 'white',
    hover2: '#113DD8',
    red2: 'red',
    muiPrimary: '#0090F9',
    muiHover: '#1565c0',
    muiDisabled: '#ACADB5',
    darkBlue: '#08193E',
    black: 'black',
  },
  calendar: {
    // app.blue
    selected: '#0090F9', // calendar.selected & calendar.selected
    inRange: '#DCF2FF',
    primary: '#303345', // calendar.primary
    secondary: '#8f95ba', // calendar.secondary
    disabled: '#ddd', // calendar.disabled
    hover: 'rgba(0, 102, 204, 0.2)', // calendar.hover
    border: '#ddd', // calendar.border
    header: '#E5F2FF',
  },
  checkbox: {
    // borders are same except for unchecked
    primaryChecked: '#0090F9', // defaultCheckboxChecked
    secondaryChecked: '#09c1d6', // altCheckboxChecked
    unchecked: 'transparent',
    uncheckedBorder: '#acadb5', // checkboxUnchecked
    disabled: '#acadb5', // checkboxDisabled
  },
  line: {
    primary: '#f0f2f7', // line.primary, line.headerBorder
    secondary: '#E6EBF7', // lineColor.horizontalContrast
    active: '#0073e5',
    headerBorder: '#f0f2f7',
  },
  scrollBar: {
    // Colors for the scroll bar
    unActiveThumb: '#d6d5da',
    thumb: '#d6d5da',
    track: 'transparent',
  },
  fontFamily: {
    primary: 'var(--font-family-primary)',
  },
  fontSize: {
    large: '1rem', // 16px
    medium: '0.875rem', // 14px
    small: '0.75rem', // 12px
  },
  timePicker: {
    active: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.26)',
  },
};

export const newLayout = {
  ...light,
  name: 'newLayout',
  borderRadius: {
    primary: 'var(--radius-md)',
    secondary: 'var(--radius-sm)',
    full: 'var(--radius-full)',
  },
  fontFamily: {
    primary: 'var(--font-family-primary)',
  },
  fontSize: {
    h1: '2.2rem',
    h2: '1.75rem',
    h3: '1.5rem',
    h4: '1.125rem',
    h5: '0.875rem',
    h6: '0.75rem',
    body1: '1rem',
    body2: '0.875rem',
    body3: '0.75rem',
    body4: '0.625rem',
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
  },
  heights: {
    xs: '24px',
    s: '32px',
    m: '40px',
    l: '48px',
    xl: '56px',
  },
  lineHeight: {
    h1: '2.5rem',
    h2: '2rem',
    h3: '1.75rem',
    h4: '1.5rem',
    h5: '1.25rem',
    h6: '0.75rem',
    body1: '1.5rem',
    body2: '1.25rem',
    body3: '1rem',
    body4: '0.625rem',
  },
  spacing: {
    s1: '4px',
    s2: '8px',
    s3: '12px',
    s4: '16px',
    m1: '20px',
    m2: '24px',
    m3: '28px',
    m4: '32px',
    l1: '36px',
    l2: '40px',
    l3: '48px',
    l4: '56px',
    xl1: '60px',
    xl2: '72px',
    xl3: '84px',
    xl4: '96px',
  },
  text: {
    ...light.text,
    primary: COLORS.kinetikBlack,
    error: COLORS.redDark,
    disabled: COLORS.black30,
  },
  border: {
    default: {
      color: COLORS.black10,
    },
    hover: {
      color: COLORS.kinetikBlack,
    },
    active: {
      color: COLORS.kinetikBlue,
    },
    disabled: {
      color: COLORS.black10,
    },
    error: {
      color: COLORS.red,
    },
    success: {
      color: COLORS.green,
    },
    filled: {
      color: COLORS.kinetikBlack,
    },
  },
};

export const dark = {
  name: 'dark',
  light: false,
  dark: true,
  app: {
    background: '#262D3B',
    primary: '#2E374A',
    accent: '#0CEFB4',
    error: '#2E374A',
    dropzone: '#242C3B',
    toggleInactive: '#475675',
    secondary: '#5dd9a5',
    resolved: '#00D17A33',
    green: '#00D17A',
    unread: '#056f7a',
    shadow: '#5dd9a555',
  },
  input: {
    hover: '#00dba4',
    focus: '#215246',
    error: '#FFEDED',
    rangeValue: '#242C3B',
    slideTrack: '#dbedff',
    slideHandle: '#14ffc4',
  },
  text: {
    smText: '#000',
    rangeValue: '#242C3B',
    link: '#0CEFB4',
    primary: '#fff',
    hover: '#ACADB5',
    navBar: '#fff',
    inputFocus: '#0CEFB4',
    inputError: '#FD5683',
    secondary: '#ACADB5',
    disabled: '#83858F',
    smTextLight: '#00000099',
    disabledTimePicker: '#a9a9a9',
  },
  buttonBg: {
    disabled: '#ffffff22',
    primary: '#40a9ff',
    green: 'transparent',
    orange: 'transparent',
    red: 'transparent',
    blue: 'transparent',
    lightBlue: 'transparent',
    primaryChecked: '#00dba4',
    unchecked: '#acadb5',
  },
  buttonText: {
    action: '#14ffc4',
    green: '#00D17A',
    red: '#fd5683',
    disabled: '#b5bbc5',
    primary: 'white',
    hover: '#40a9ff',
    blue: '#0073E5',
    orange: '#FF8B33',
    lightBlue: '#04BDD6',
  },
  calendar: {
    header: '#25594c',
    selected: '#00c994',
    primary: '#fff',
    secondary: '#999',
    disabled: '#5e5e5e',
    border: '#5e5e5e',
    hover: 'rgba(0, 194, 142, 0.5)',
  },
  checkbox: {
    secondaryChecked: '#09c1d6',
    disabled: '#acadb5',
    uncheckedBorder: '#acadb5',
    primaryChecked: '#00dba4',
    unchecked: 'transparent',
  },
  line: {
    active: '#0CEFB4',
    headerBorder: '#3D4861',
    primary: '#5F6677',
    secondary: '#9a99a3',
  },
  scrollBar: {
    // Colors for the scroll bar
    thumb: '#eaeaea',
  },
  fontSize: {
    large: '1rem', // 16px
    medium: '0.875rem', // 14px
    small: '0.75rem', // 12px
  },
};
